import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import Cookies from "cookies-js";
import * as tools from "../../helpers/Tools";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import * as msgs from "../../constants/textConstants";
import { isValidDate } from "../../helpers/dateTime";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { logReactError } from "../../api/loggingApi";


class EnsureLoggedIn extends React.Component {

    constructor(props) {
        super(props);

        this.buildUniqueID = this.buildUniqueID.bind(this);
        this.startCountDownTimer = this.startCountDownTimer.bind(this);
        this.clearCountDownTimer = this.clearCountDownTimer.bind(this);
        this.countdownTimerTick = this.countdownTimerTick.bind(this);
        this.setupClickHandlers = this.setupClickHandlers.bind(this);
        this.clearInactivityTimer = this.clearInactivityTimer.bind(this);
        this.setInactivityTimer = this.setInactivityTimer.bind(this);
        this.timedOut = this.timedOut.bind(this);
        this.resetInactivityTimer = this.resetInactivityTimer.bind(this);
        this.newClickHandler = this.newClickHandler.bind(this);
        this.newKeypressHandler = this.newKeypressHandler.bind(this);
        this.clearClickHandlers = this.clearClickHandlers.bind(this);
        this.callRefreshToken = this.callRefreshToken.bind(this);
        this.setTimer = this.setTimer.bind(this);
        this.cleanupTimer = this.cleanupTimer.bind(this);
        this.resetCountersFromProperties = this.resetCountersFromProperties.bind(this);
        this.resetCountersFromProperties();
    }

    componentWillMount() {
        console.log("Ensured logged in-componentWillMount");
    }

    resetCountersFromProperties() {
        this.idleTimeoutSeconds = window.serverData.data.idleTimeoutSeconds;
        this.idleTimeoutCountdownSeconds = window.serverData.data.idleTimeoutCountdownSeconds;

        if (this.props.attributeIdleTimeoutSeconds) {
            this.idleTimeoutSeconds = this.props.attributeIdleTimeoutSeconds;
        }
        if (this.props.attributeIdleTimeoutCountdownSeconds) {
            this.idleTimeoutCountdownSeconds = this.props.attributeIdleTimeoutCountdownSeconds;
        }

    }

    componentDidMount() {
        const { isLoggedIn, currentURL, setRedirectUrl, refreshToken } = this.props;

        this.bHasWindow = (typeof window !== "undefined");

        const sPath = tools.getURLPath(this.props.attributePath).toLowerCase();

        if (!isLoggedIn && sPath !== '/login') {
        }

        this.resetCountersFromProperties();
        this.resetInactivityTimer();

        this.setupClickHandlers();

        this.setTimer();

        if (this.uniqueID !== null) {
            //debugger;
        }
        else {
            this.uniqueID = this.buildUniqueID();
        }

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // we're not resetting the inactivity timer, only the reset token timer
        const { token, isLoggedIn } = this.props;
        if (prevProps.token !== token) { // update the refresh timer any time the token changes
            this.setTimer();
        }
        if (!prevProps.isLoggedIn && isLoggedIn) { // here, we start the idle count down timer 
            this.setInactivityTimer();
            this.setTimer();
        }
        if (!isLoggedIn && prevProps.isLoggedIn) {
            this.clearCountDownTimer(); // clear the countdown timer whenever we logout
            this.clearInactivityTimer();
        }

    }

    componentWillUnmount() {
        //alert("Will unmount!");
        console.log("Ensured logged in-componentWillUnmount");
        this.clearInactivityTimer();
        this.clearClickHandlers();
        this.cleanupTimer();
    }

    bHasWindow = false;

    uniqueID = null;

    refreshTimer = null;
    timerToken = null;

    inactivityTimer = null;
    inactivityTimerStartTime = null;

    originalOnKeypress = null;
    originalOnClick = null;
    handlerSet = null;

    dialogIsOpen = false;
    idleTimeoutSeconds = 60;
    idleTimeoutCountdownSeconds = 60;

    countdownSecondsRemaining = 60;
    countdownTimer = null;

    buildUniqueID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    startCountDownTimer() {
        this.clearCountDownTimer();
        if (!this.props.isMobile) {
            this.countdownSecondsRemaining = this.idleTimeoutCountdownSeconds;
            if (this.isTokenExpired()) {
                console.log("CountDown timer thinks the token is expired");
                this.systemLogout();
            } else {
                console.log("CountDown timer is being start");
                this.countdownTimer = window.setInterval(this.countdownTimerTick, 1000);
            }
        }
        else {
            console.log("CountDown timer thinks it's mobile");
        }
    }

    clearCountDownTimer() {
        if (this.countdownTimer !== null) {
            if (this.bHasWindow) {
                window.clearInterval(this.countdownTimer);
            }
            this.countdownTimer = null;
        }
    }

    countdownTimerTick() {
        if (this.isTokenExpired()) {
            logUI("MBHWeb.Login.TokenExpired.Logout", new Date(), Tools.getURLPath());
            //debugger;
            this.systemLogout();
        } else {
            this.countdownSecondsRemaining = this.countdownSecondsRemaining - 1;
            if (this.countdownSecondsRemaining < 1) {
                logUI("MBHWeb.Login.SessionExpired.Logout", new Date(), Tools.getURLPath());
                this.clearCountDownTimer();
                //debugger;
                this.systemLogout();

                // Since this has a global life, even on the login page now, we must do this
                this.resetCountersFromProperties();
                this.resetInactivityTimer();
                this.cleanupTimer();  // componentDidUpdate will restart the timer when needed

            };
            this.forceUpdate();
        }
    }



    setupClickHandlers() {
        if (this.bHasWindow) {
            window.addEventListener("click", this.newClickHandler, false);
            window.addEventListener("keypress", this.newKeypressHandler, false);
        }
    }

    clearInactivityTimer() {
        if (this.inactivityTimer !== null) {
            if (this.bHasWindow) {
                window.clearTimeout(this.inactivityTimer);
            }
            this.inactivityTimer = null;
            this.inactivityTimerStartTime = null;
        }
    }

    setInactivityTimer() {

        if (!this.props.isMobile) {

            if (this.inactivityTimer === null) {

                if (this.bHasWindow) {
                    this.inactivityTimer = window.setTimeout(this.timedOut, this.idleTimeoutSeconds * 1000);
                    this.inactivityTimerStartTime = new Date();
                }
            }
        }
    }


    timedOut() {
        const { isMobile } = this.props;
        if (window.twilioRoom //window.lastTwilio && 
        //    Number.isInteger(window.lastTwilio) &&
        //    window.lastTwilio > 0 &&
        //    Date.now() < window.lastTwilio + (this.idleTimeoutSeconds * 1000)
        ) {
            this.resetInactivityTimer(); // We reset the timer in case we timed out while jitsi was up
            return;
        }

        if (!isMobile) {
            if (!this.props.isLoggedIn) {
                //alert("Ok... you're not logged in so we'll just silently reload the timer here.");
                this.resetInactivityTimer();
            }
            else {
                //if it has been longer than the inactivity timer time plus the countdown time, go ahead and log out the user
                let inactivityTimedOut = +new Date() - (+this.inactivityTimerStartTime + +this.idleTimeoutCountdownSeconds)
                if (inactivityTimedOut / 1000 >= (this.idleTimeoutSeconds + 5) || this.isTokenExpired()) {  // we add 5 here because timing might bring this line of code in 1 second latr
                    //debugger;
                    this.systemLogout()
                } else {
                    // popup here
                    this.dialogIsOpen = true;
                    this.startCountDownTimer();
                    //alert("Heh!! Do something! You're logged in!");
                }
            }
        }
    }

    resetInactivityTimer() {
        this.clearCountDownTimer();
        this.clearInactivityTimer();
        this.setInactivityTimer();
        if (this.dialogIsOpen) {
            this.dialogIsOpen = false;
            this.forceUpdate();
        }
    }

    newClickHandler() {
        this.resetInactivityTimer();
        if (this.originalOnClick !== null) {
            this.originalOnClick();
        }
    }

    newKeypressHandler() {
        this.resetInactivityTimer();
        if (this.originalOnKeypress !== null) {
            this.originalOnKeypress();
        }
    }

    clearClickHandlers() {
        if (this.bHasWindow) {
            window.removeEventListener("keypress", this.newKeypressHandler);
            window.removeEventListener("click", this.newClickHandler);
        }
    }



    componentDidCatch(error, errorInfo) {
        console.log("ErrTEST:" + error);
        let json = { error: error, componentStack: errorInfo };
        logUI("MBHWeb.UI.MainErrorBoundary.ComponentDidCatch", new Date(), Tools.getURLPath(), JSON.stringify(error), JSON.stringify(errorInfo));
    }

    callRefreshToken() {
        console.log('call refresh token');
        console.log('is token expired', this.isTokenExpired())
        if (this.props) {
            if (this.props.refreshToken && this.props.refresh_token && this.props.isLoggedIn && !this.isTokenExpired()) {
                this.props.refreshToken(this.props.refresh_token);
                logUI("MBHWeb.Login.Call.RefreshToken", new Date(), Tools.getURLPath());
            }
        }
    }

    isTokenExpired = () => {
        var dateExpire = new Date(this.props.expiresDate);
        var dateNow = new Date();
        if (dateExpire.getTime() - dateNow.getTime() <= 0) {
            return true;
        } else {
            return false;
        }
    }

    systemLogout = () => {
        this.props.logout(msgs.SystemInitiatedLogoutMessage);
    }

    setTimer() {
        if (!this.props.isLoggedIn) {
            this.cleanupTimer();
        }
        else {
            if (this.props.token !== this.timerToken && this.timerToken !== null) {
                this.cleanupTimer();
            }
            if (!this.props.isMobile) {
                if (this.props.expiresDate) {
                    var dateThen = new Date(this.props.expiresDate);
                    var dateNow = new Date();
                    var elapsed = Math.floor((dateThen.getTime() - dateNow.getTime()) / 1000);
                    var remaining = elapsed - (5 * 60);
                    if (remaining < 1) {
                        this.callRefreshToken();
                    }
                    else {
                        if (this.props.token !== null && (this.timerToken === null || this.timerToken === undefined || this.timerToken !== this.props.token)) {
                            this.timerToken = this.props.token;
                            if (this.bHasWindow) {
                                this.refreshTimer = window.setTimeout(this.callRefreshToken, remaining * 1000);
                            }
                        }
                    }
                }
            }
        }
    }

    cleanupTimer() {
        if (this.refreshTimer !== null) {
            if (this.bHasWindow) {
                window.clearTimeout(this.refreshTimer);
            }
            this.refreshTimer = null;
            this.timerToken = null;
        }
    }


    render() {
        var isClientSide = this.bHasWindow;

        if (this.props.isLoggedIn) {
            return (
                <React.Fragment>
                    {this.props.children}
                    <Modal isOpen={this.dialogIsOpen} toggle={this.resetInactivityTimer} centered backdrop="static" className="ensureloggedin-modal">
                        <ModalBody>
                            <h2 className="modal-heading">Are you still there?</h2>
                            <p>You will be logged out in <span id="spanIdleTimeout">{this.countdownSecondsRemaining}</span> seconds due to inactivity.</p>
                        </ModalBody>
                        <ModalFooter>
                            <button className="btn btn-primary" onClick={this.resetInactivityTimer}>STAY LOGGED IN</button>
                            <button className="btn btn-primary" onClick={() => this.props.logout(msgs.UserInitiatedLogoutMessage)}>LOG ME OUT</button>
                        </ModalFooter>
                    </Modal>
                </React.Fragment>
            );
        }
        else {
            this.cleanupTimer();  // need to do this for cases where we get logged out after the timer is configured.  Timer will continue to fire and countdown and change the message
            this.clearCountDownTimer();
        }
        return <div />;
    }
}

function mapStateToProps(state, ownProps) {
    var oProps = {
        isLoggedIn: state.domain.li,
        token: state.domain.t,
        expires_in: state.sso.userDetails ? state.sso.userDetails.expires_in : null,
        expiresDate: state.sso.userDetails ? state.sso.userDetails.expiresDate : null,
        dateLoaded: state.sso.userDetails ? state.sso.userDetails.dateLoaded : null,
        refresh_token: state.domain.rt,
        currentURL: ownProps.location ? ownProps.location.pathname : null,
        redirectURL: window.redirectURL ? window.redirectURL : "/",
        isMobile: state.domain.mq
    };

    return oProps;
}

const mapDispatchToProps = (dispatch) => {
    return {
        refreshToken: function (sRefreshToken) {
            return dispatch({
                type: types.USER_AUTHENTICATE_REFRESH,
                refresh_token: sRefreshToken
            });
        },
        logout: function (sLogoutMessage) {
            return dispatch({
                type: types.LOGOUT, logoutMessage: sLogoutMessage
            });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EnsureLoggedIn);